
import CodeSnippet from '@/components/molecules/code-snippet/code-snippet';

export default {
  name: 'TrackingCodeExample',

  components: {
    CodeSnippet,
  },
};
